var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StaffManage-list"},[_c('GlobalInfoBar',{attrs:{"title":"赠品管理","content":"添加礼包里的赠品内容"}}),_c('GlobalChunk',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('From',{on:{"seeExample":_vm.seeExample}})],1),_c('Table',{on:{"seeExample":_vm.seeExample}})],1),(_vm.showViewer)?_c('el-image-viewer',{staticStyle:{"z-index":"999999999"},attrs:{"on-close":() => {
        _vm.showViewer = false;
      },"url-list":_vm.imgList}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }